import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const EmployeesListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    {
      variable: 'key',
      text: t('custom_fields_employees.fields.key') + ': ',
      type: 'h3',
    },
    { variable: 'name', text: t('custom_fields_employees.fields.name') + ': ' },
    {
      variable: 'description',
      text: t('custom_fields_employees.fields.type') + ': ',
    },
    {
      variable: 'active',
      text: t('custom_fields_employees.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.custom_employee.update',
    togglePermission: 'acl.custom_employee.toggle',
    editUrl: 'employees', //Url para editar empleado
    propsName: 'employee', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('custom_fields_employees.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('custom_fields_employees.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="type"
            handleOrderChange={handleOrderChange}
          >
            {t('custom_fields_employees.fields.type')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('custom_fields_employees.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(EmployeesListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/list/EmployeesListTable.js